import 'reflect-metadata';
import './styles/index.scss';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { configure } from 'mobx';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';

configure({ useProxies: 'never' });

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <App />
    </StrictMode>,
);
